import React from 'react'
import { Section } from '@shared/components/section'
import { ExternalPaths } from '@shared/menu-items/paths'
import cx from 'classnames'
import { Image } from 'shared/components/image'

import styles from './style.module.scss'

export const View = () => {
	return (
		<>
			<Image name='team.jpg' lazy className={styles.image} alt='Команда Credit.Club' />
			<Section className={styles.box}>
				<h2 className={styles.title}>
					В&nbsp;команде <span className={styles.cyan}>более 40&nbsp;специалистов</span>{' '}
					со&nbsp;всей России и&nbsp;СНГ
				</h2>
				<a
					href={ExternalPaths.workWithUs}
					target='_blank'
					rel='noopener noreferrer nofollow'
					className={cx(styles.subtitle, styles.cyan)}
				>
					Работа у нас{' '}
				</a>
				<p className={styles.paragraph}>
					Мы считаем, что в бизнесе есть две самые важные составляющие — клиенты и команда. У нас
					получилось собрать сильных специалистов с опытом работы в банках и крупных IT-компаниях.
				</p>
				<p className={styles.paragraph}>
					Границы — не помеха для Credit.Club. Мы умеем работать дистанционно, что позволяет искать
					лучших специалистов из разных регионов страны и ближайшего зарубежья.
				</p>
			</Section>
		</>
	)
}
